import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-full" }
const _hoisted_2 = { class: "p-4 bg-white" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "grow" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center" }
const _hoisted_7 = ["onKeydown"]
const _hoisted_8 = { class: "ml-4" }
const _hoisted_9 = { class: "flex space-x-4" }
const _hoisted_10 = { class: "p-4" }
const _hoisted_11 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
}
const _hoisted_12 = { class: "flex-1 flex flex-col p-8" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mt-6 text-gray-500 text-sm font-medium" }
const _hoisted_15 = { class: "mt-1 text-gray-500 text-xs flex-grow flex flex-col justify-between" }
const _hoisted_16 = { key: 0 }

import Decedent from "@/models/Decedent";
import Followable from "@/models/Followable";
import Temple from "@/models/Temple";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import AppHeader from "@/components/AppHeader.vue";
// import Followable from "../models/Followable";
// import Temple from "../models/Temple";
// import Decedent from "../models/Decedent";

// @Options({
//   components: {
//     SearchIcon,
//     AppHeader,
//   },
// })
// export default class SearchView extends Vue {

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchView',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";
// import { SearchIcon } from "@heroicons/vue/solid";

const store = useStore();

const target = ref<string>("temple");
const keyword = ref<string>("");

const followables = ref<Followable[]>([]);

const setTarget = (type: string) => {
  target.value = type;
  refresh();
};

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      followables.value = [];

      if (target.value == "temple") {
        const result = await Temple.search(keyword.value);

        followables.value = [];
        result.temples.forEach((temple) => {
          followables.value.push(temple as Followable);
        });
      } else {
        const result = await Decedent.search(keyword.value, !keyword.value);

        followables.value = [];
        result.decedents.forEach((deceent) => {
          followables.value.push(deceent as Followable);
        });
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_fa, {
                  icon: "search",
                  class: "h-5 w-5 text-gray-400"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "block w-full border-gray-400 border border-transparent rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-400 sm:text-sm",
                placeholder: "寺院名、個人名などを入力してください",
                type: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
                onKeydown: _withKeys(refresh, ["enter"])
              }, null, 40, _hoisted_7), [
                [_vModelText, keyword.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("nav", _hoisted_9, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: _normalizeClass(["border border-gray-300 rounded-md px-3 py-2 font-medium text-xs rounded-md", {
                'bg-color-2': target.value == 'temple',
                'text-gray-300 ': target.value !== 'temple',
                'text-white': target.value == 'temple',
              }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setTarget('temple')))
              }, "寺院 ", 2),
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: _normalizeClass(["border border-gray-300 rounded-md px-3 py-2 font-medium text-xs rounded-md", {
                'bg-color-2': target.value == 'decedent',
                'text-gray-300 ': target.value !== 'decedent',
                'text-white': target.value == 'decedent',
              }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (setTarget('decedent')))
              }, "故人 ", 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("ul", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followables.value, (followable) => {
            return (_openBlock(), _createElementBlock("li", {
              key: followable.id,
              class: "col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
            }, [
              _createVNode(_component_router_link, {
                to: 
              followable.type == 'temple'
                ? `/temples/${followable.id}`
                : `/decedents/${followable.id}`
            
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      class: "w-32 h-32 flex-shrink-0 mx-auto rounded-full",
                      src: 
                  followable.selfie_image_url ?? (followable.type == 'temple' ? require('@/assets/images/no-selfie-temple.png') : require('@/assets/images/no-selfie.png'))
                ,
                      alt: ""
                    }, null, 8, _hoisted_13),
                    _createElementVNode("h3", _hoisted_14, _toDisplayString(followable.display_name), 1),
                    _createElementVNode("dl", _hoisted_15, [
                      (followable.full_address)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_16, _toDisplayString(followable.full_address), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})